import { isKnownCategory } from './Categories';
import { isKnownContentType } from './ContentTypeUtils';

export const ALMA_INSIGHTS_CALLBACK_URL =
  'https://sisaltopalvelut.almainsights.fi/omat-sisallot';

export const externalLegalInsightsLinks = [
  {
    id: 'suomen_laki',
    label: 'Suomen Laki',
    href: 'https://suomenlaki.almainsights.fi',
  },
  {
    id: 'verkkokirjahylly',
    label: 'Verkkokirjahylly',
    href: 'https://verkkokirjahylly.almainsights.fi',
  },
  {
    id: 'lakikoulutus',
    label: 'Lakikoulutus',
    href: 'https://koulutus.almainsights.fi/juristiliiton-koulutus/',
  },
  {
    id: 'sijoituskirjasto',
    label: 'Sijoituskirjasto',
    href: 'https://sijoituskirjasto.almainsights.fi/sijoituskirjasto#Sijoituskirjasto',
  },
];

export enum JaaRoute {
  frontPage = '/',
  contentIndex = '/sisallot',
  articleShow = '/sisältö/',
  articleSearch = '/haku',
  regulationIndex = '/seuranta',
  authorShow = '/asiantuntijat/',
  authorListPage = '/asiantuntijat',
  newsIndex = '/uutiset',
  frontPageAfterLogin = 'login/callback',
  register = '/register',
  frontPageAfterLogout = 'logout/callback',
  ssoLoginRedirect = '/sso-login/:connection',
}

export function getSsoLoginPath(connection: string): string {
  return `/sso-login/${connection}`;
}

export function getRouterPathToContentIndex(
  category?: string,
  contentType?: string,
) {
  const searchParams = new URLSearchParams();

  if (!category && !contentType) {
    return JaaRoute.contentIndex;
  }

  if (contentType) {
    searchParams.set('contentType', contentType);
  }

  if (category) {
    searchParams.set('category', category);
  }

  return `${JaaRoute.contentIndex}?${searchParams.toString()}`;
}

export function getRouterPathToArticle(id: string) {
  return JaaRoute.articleShow + encodeURIComponent(id);
}

export function getRouterPathToAuthor(author: string) {
  return JaaRoute.authorShow + encodeURIComponent(author);
}

export const customerServiceEmail = 'sisaltopalvelut@almainsights.fi';
export const customerServicePhone = '0800 141 070';
export const marketingSiteUrl =
  'https://www.almainsights.fi/juridiikan-ajankohtaiset';

export const isDeprecatedContentIndexRoute = (
  requestUrl: string,
  routeParam?: string,
): boolean => {
  /* Old route paths to support
      - /sisallot/:category
      - /sisallot/:category?contentType=some-content-type
      - /sisallot/:contentType
      - /sisallot/:contentType?category=some-category
    */

  // Check if the routeParam is a known content type
  if (routeParam && isKnownContentType(routeParam)) {
    return true;
  }

  if (routeParam && isKnownCategory(routeParam)) {
    return true;
  }

  // Check if URL has query params
  const url = new URL(requestUrl);
  const contentType = url.searchParams.get('contentType');
  const category = url.searchParams.get('category');

  return contentType !== null || category !== null;
};

export const getNewContentIndexPathFromOld = (
  url: string,
  routeParam?: string,
): string => {
  const currentSearchParams = new URLSearchParams(new URL(url).searchParams);
  const searchParams = new URLSearchParams();

  const category = currentSearchParams.get('contentType');
  const contentType = currentSearchParams.get('category');

  if (category || isKnownContentType(routeParam)) {
    searchParams.set('contentType', category ?? routeParam ?? '');
  }

  if (contentType || isKnownCategory(routeParam)) {
    searchParams.set('category', contentType ?? routeParam ?? '');
  }

  // Add search params only if they exist
  const search =
    searchParams.toString().length > 0 ? `?${searchParams.toString()}` : '';

  return `${JaaRoute.contentIndex}${search}`;
};
